



























































































import { Carousel, Slide } from 'vue-carousel';
import ArrowLeft from 'vue-material-design-icons/ChevronLeft.vue';
import ArrowRight from 'vue-material-design-icons/ChevronRight.vue';
import { PropType } from 'vue';
import SubjectCard from '@/components/cards/SubjectCard.vue';
import SubjectModel from '@/models/SubjectModel';

export default {
  components: {
    SubjectCard,
    Carousel,
    Slide,
    ArrowLeft,
    ArrowRight,
  },
  props: {
    subjects: {
      type: Array as PropType<SubjectModel[]>,
      required: true,
    },
  },
  data() {
    return {
      canAdvanceBackward: false,
      canAdvanceForward: false,
    };
  },
  mounted() {
    this.checkPage();
  },
  updated() {
    this.checkPage();
  },
  methods: {
    nextSlide() {
      this.$refs.subject_carousel.goToPage(
        this.$refs.subject_carousel.getNextPage(),
      );
      this.checkPage();
    },
    prevSlide() {
      this.$refs.subject_carousel.goToPage(
        this.$refs.subject_carousel.getPreviousPage(),
      );
      this.checkPage();
    },
    checkPage() {
      this.canAdvanceBackward = this.$refs.subject_carousel.canAdvanceBackward;
      this.canAdvanceForward = this.$refs.subject_carousel.canAdvanceForward;
    },
  },
};
